module.exports = __webpack_public_path__ + "static/media/2021 - 22 Edmond Chan-min.fd8cbf93.jpg";